import { render, staticRenderFns } from "./TableDoctor.vue?vue&type=template&id=4f383af4"
import script from "./TableDoctor.vue?vue&type=script&lang=js"
export * from "./TableDoctor.vue?vue&type=script&lang=js"
import style0 from "./TableDoctor.vue?vue&type=style&index=0&id=4f383af4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports